"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("@ccw-pwa-ui/Button");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
require("../styles/OwnerMobileFirstVisitComponent.css");
const OwnerMobileFirstVisitComponent = _ref => {
  let {
    ownerMobileString,
    handleCreateStore,
    userType
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "od-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "od-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "od-body"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "ownerFirstVisitImage",
    src: _index.default.ownerFirstVisit.default,
    alt: "first Visit Store"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "od-sub-content"
  }, ownerMobileString.SUB_CONTENT), /*#__PURE__*/_react.default.createElement("div", {
    className: "od-main-content"
  }, ownerMobileString.MAIN_CONTENT), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeDashboart-addStorebtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: "Add Store",
    onClick: handleCreateStore
  })))));
};
var _default = exports.default = OwnerMobileFirstVisitComponent;